function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// 获取接口请求URL
var apiBaseUrl = typeof window !== 'undefined' ? window.envConfig && window.envConfig.VUE_APP_PC_B_BASE_URL || '' : '';
var getReqUrl = function getReqUrl(key) {
  // 接口请求地址
  var apiUrl = {
    qw: '/wxwork/v1/js_sdk_sign/both',
    wx: '/wxopen/v1/wxpublic/jsSDKSign',
    idmapping: '/wxwork/v1/id/query/batch/idmapping/v1',
    login: '/biz/v1/qw_account/session/get_login_session'
  };
  return "" + apiBaseUrl + apiUrl[key];
};
// 请求接口方法
var $jsdkHttp = function $jsdkHttp(options) {
  var headers = options.headers;
  var url = options.url;
  var paramsStr = '';
  Object.entries(options.params).forEach(function (arr) {
    if (arr[0]) {
      paramsStr += "" + (paramsStr ? '&' : '') + arr[0] + "=" + (arr[1] || '');
    }
  });
  if (options.method === 'get') {
    url += "?" + paramsStr;
    paramsStr = '';
  }
  var jsdkxhr = new XMLHttpRequest();
  jsdkxhr.open(options.method, url, true);
  if (options.method === 'post') {
    // 设置header
    jsdkxhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    paramsStr = JSON.stringify(options.params);
  }
  jsdkxhr.setRequestHeader('Access-Control-Allow-Origin', '*');
  jsdkxhr.setRequestHeader('Accept', '*/*');
  if (headers && headers !== null && typeof headers === 'object') {
    for (var key in headers) {
      jsdkxhr.setRequestHeader(key, headers[key]);
    }
  }
  jsdkxhr.send(paramsStr);
  return new Promise(function (resolve, reject) {
    jsdkxhr.onload = function (res) {
      if (Math.floor(jsdkxhr.status / 100) === 2) {
        resolve(JSON.parse(jsdkxhr.response) || {});
      }
      resolve(res);
    };
    jsdkxhr.onerror = function (res) {
      reject(res);
    };
  });
};

var setLoadWxSdk = (function (sdkUrl) {
  if (sdkUrl === void 0) {
    sdkUrl = '//res.wx.qq.com/open/js/jweixin-1.2.0.js';
  }
  return new Promise(function (resolve, reject) {
    console.log('进入【设置问下分享skd url函数】');
    if (window.wx && window.wx.ready) {
      console.log('window.wx && window.wx.ready已存在，跳过手动设置微信sdk url');
      resolve(true);
    } else if (sdkUrl) {
      console.log('手动设置微信sdk url-【开始】');
      // 判断是否为新版本的sdk
      var version = sdkUrl.split('jweixin-')[1];
      console.log("\u5F53\u524Dsdk\u7248\u672C\u4E3A\uFF1A" + version);
      // url协议
      if (!sdkUrl.match('http')) sdkUrl = window.location.protocol + sdkUrl;
      var script = document.createElement('script');
      if (script.readyState) {
        // IE
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            if (window.wx && window.wx.ready) {
              console.log('手动设置微信sdk url-【成功】');
              resolve(true);
            } else {
              var err = new Error('微信jssdk引入失败，可能是sdk url错误，请正确引入！官方文档：https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#3');
              reject(err);
            }
          }
        };
      } else {
        // 其他浏览器
        script.onload = function () {
          if (window.wx && window.wx.ready) {
            console.log('手动设置微信sdk url-【成功】');
            resolve(true);
          } else {
            var err = new Error('微信jssdk引入失败，可能是sdk url错误，请正确引入！官方文档：https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#3');
            reject(err);
          }
        };
      }
      script.setAttribute('src', sdkUrl);
      script.setAttribute('data-namespace', sdkUrl + "-" + new Date().getTime());
      if (document.body) {
        document.body.appendChild(script);
      } else {
        document.head.appendChild(script);
      }
    } else {
      var err = new Error('微信sdk url为空，手动设置微信sdk url-【失败】');
      reject(err);
    }
  });
});

var _navigator$userAgent$;
function isBrowser() {
  return typeof window !== 'undefined';
}
// 判断是否为微信环境(企微/个微)
var isMicromessenger = /*#__PURE__*/isBrowser() && /*#__PURE__*/ /micromessenger/i.test(window.navigator.userAgent);
// 判断是否为企微环境
var isWxwork = /*#__PURE__*/isBrowser() && /*#__PURE__*/ /wxwork/i.test(window.navigator.userAgent);
// 判断是否执行企微模式：如果不是微信环境，则均执行企微模式
var isQw = isWxwork || !isMicromessenger;
// 判断是否为个微环境
var isWx = !isQw;
// 是否为Ios设备访问
var isIOS = /*#__PURE__*/isBrowser() && /*#__PURE__*/ /(iPhone|iPod|iPad|ios)/i.test(window.navigator.userAgent);
// 企微版本
var wxworkVersion = isWxwork ? (_navigator$userAgent$ = /*#__PURE__*/navigator.userAgent.match(/wxwork\/([\d.]+)/)) == null ? void 0 : _navigator$userAgent$[1] : null;
// 获取URL携带的参数
function fquery() {
  var query = window.location.hash.split('?')[1] || window.location.search.substr(1);
  var reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
  var obj = {};
  while (reg.exec(query)) obj[RegExp.$1] = RegExp.$2;
  window.urlQueryObj = obj;
  return obj;
}
// 获取id
var getIdmapping = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params, idmapping, contact) {
    var _ids;
    var ids, sid, opts, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (idmapping === void 0) {
            idmapping = false;
          }
          if (contact === void 0) {
            contact = true;
          }
          ids = params.ids;
          if (!(idmapping && (_ids = ids) != null && _ids.length)) {
            _context.next = 19;
            break;
          }
          _context.prev = 4;
          sid = params.sid;
          if (sid) delete params.sid;
          opts = {
            method: 'post',
            url: getReqUrl('idmapping'),
            params: params
          };
          if (sid) {
            opts.headers = {
              'Authorization': sid
            };
          }
          _context.next = 11;
          return $jsdkHttp(opts);
        case 11:
          res = _context.sent;
          if (res.success) {
            ids = res.data;
          }
          console.log('res: idmapping', res);
          _context.next = 19;
          break;
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](4);
          console.log('error: ', _context.t0);
        case 19:
          return _context.abrupt("return", contact ? ids.join(';') : ids);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 16]]);
  }));
  return function getIdmapping(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
function getCookie(name) {
  // 获取所有cookie
  var cookies = document.cookie.split(';');
  // 遍历所有cookie
  for (var i = 0; i < cookies.length; i++) {
    // 去除cookie前后的空格
    var cookie = cookies[i].trim();
    // 检查当前cookie是否以指定的名称开头
    if (cookie.startsWith(name + '=')) {
      // 返回cookie的值
      return cookie.substring(name.length + 1);
    }
  }
  // 如果未找到cookie，返回null
  return null;
}
// 获取请求参数
var getParams = function getParams() {
  var urlQueryObj = fquery();
  var jsdkLocalConfig = JSON.parse(window.localStorage.getItem('config') || '{}');
  var jssdkLocalUser = JSON.parse(window.localStorage.getItem('use') || '{}');
  var jsdkParams = {
    corpId: urlQueryObj.corpId || urlQueryObj.corpid || jsdkLocalConfig.corpId || jsdkLocalConfig.corpid,
    agentId: urlQueryObj.agentId || urlQueryObj.agentid || jsdkLocalConfig.agentId || jsdkLocalConfig.agentid,
    account: urlQueryObj.account || jsdkLocalConfig.account,
    isSideMenu: urlQueryObj.isSideMenu || jsdkLocalConfig.isSideMenu,
    appId: urlQueryObj.appId || jsdkLocalConfig.appId,
    sid: urlQueryObj.sessionId || jssdkLocalUser.sid || getCookie('platform-sid') || jsdkLocalConfig.sid
  };
  if (urlQueryObj.account || urlQueryObj.corpId || urlQueryObj.corpid || urlQueryObj.agentId || urlQueryObj.agentid) {
    window.localStorage.setItem('config', JSON.stringify(jsdkParams));
  }
  return jsdkParams;
};
// 登录
var jsdkAutoLoginFunc = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(cb) {
    var urlQueryObj, res, params;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          urlQueryObj = fquery();
          res = null;
          if (!urlQueryObj.sessionId) {
            _context2.next = 14;
            break;
          }
          params = {
            sessionId: urlQueryObj.sessionId,
            type: urlQueryObj.isSideMenu ? 'cbl' : 'qw'
          };
          _context2.prev = 4;
          _context2.next = 7;
          return $jsdkHttp({
            url: getReqUrl('login'),
            method: 'get',
            params: params
          });
        case 7:
          res = _context2.sent;
          if (res.success) {
            window.localStorage.setItem('user', JSON.stringify(res.data));
          }
          _context2.next = 14;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](4);
          console.log('error: ', _context2.t0);
        case 14:
          if (typeof cb === 'function') {
            cb(res);
          }
          return _context2.abrupt("return", res);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 11]]);
  }));
  return function jsdkAutoLoginFunc(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
function compareVersions(version1, version2) {
  var v1Parts = version1.split('.').map(Number);
  var v2Parts = version2.split('.').map(Number);
  var length = Math.max(v1Parts.length, v2Parts.length);
  for (var i = 0; i < length; i++) {
    var v1Part = v1Parts[i] || 0;
    var v2Part = v2Parts[i] || 0;
    if (v1Part > v2Part) {
      return 1;
    } else if (v1Part < v2Part) {
      return -1;
    }
  }
  return 0;
}
var showMessage = function showMessage(text) {
  if (text === void 0) {
    text = '企业微信版本过低，请升级至最新版本，否则部分功能无法使用';
  }
  if (window.sessionStorage.getItem('__hasLowVersionMention')) return;
  var divStyle = "\n      position: fixed;\n      top: 20%;\n      left: 50%;\n      color: #fff;\n      transform: translate3d(-50%, -50%, 0);\n      background: rgba(0, 0, 0, 0.7);\n      font-size: 14px;\n      width: 80%;\n      padding: 8px 16px;\n      transition: all .3s;\n      z-index: 99;\n      text-align: center;\n      box-sizing: border-box;\n      opacity: 1;\n  ";
  // 创建一个新的 div 元素
  window.onload = function () {
    var newDiv = document.createElement('div');
    newDiv.style.cssText = divStyle;
    newDiv.innerHTML = text;
    document.body.appendChild(newDiv);
    window.sessionStorage.setItem('__hasLowVersionMention', '1');
    setTimeout(function () {
      newDiv.style.opacity = '0';
      setTimeout(function () {
        newDiv.style.display = 'none';
      }, 500);
    }, 4000);
  };
};
var isLowWxworkVersion = function isLowWxworkVersion() {
  if (!isWxwork) return false;
  if (typeof wxworkVersion !== 'string') return false;
  return compareVersions('4.0.16', wxworkVersion) === 1;
};

// 控制分享按钮
var shareList = ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone'];
// 控制复制按钮
var shareCopyList = ['menuItem:copyUrl'];
// 个微分享时需要注册的方法
var wxShareConfig = ['agentConfig', 'checkJsApi', 'updateTimelineShareData', 'updateAppMessageShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'showMenuItems', 'hideMenuItems'];
// 企微分享时需要注册的方法
var qwShareConfig = ['agentConfig', 'onMenuShareAppMessage', 'onMenuShareWechat', 'onMenuShareTimeline', 'openDefaultBrowser', 'hideOptionMenu', 'showOptionMenu'];
var qwRegisterJsApiList = ['previewFile', 'openEnterpriseChat', 'getCurExternalChat', 'onHistoryBack', 'agentConfig', 'openDefaultBrowser', 'setClipboardData', 'hideMenuItems', 'showMenuItems', 'onMenuShareAppMessage', 'hideOptionMenu', 'showOptionMenu', 'openAddress', 'launchMiniprogram', 'getLocation', 'navigateToAddCustomer', 'chooseImage', 'shareToExternalContact', 'openExistedChatWithMsg', 'shareToExternalMoments'];
var qwVerifyJsApiList = ['selectExternalContact', 'sendChatMessage', 'getCurExternalContact', 'getCurExternalChat', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems', 'hideOptionMenu', 'showOptionMenu', 'setClipboardData', 'openAddress', 'shareToExternalContact', 'launchMiniprogram', 'getLocation', 'navigateToAddCustomer', 'chooseImage', 'openExistedChatWithMsg', 'shareToExternalMoments'];

var CfxJsSdkInit = /*#__PURE__*/function () {
  function CfxJsSdkInit(config) {
    var _this = this;
    this.sdkPendingList = [];
    this.baseConfig = {
      account: '',
      companyId: '',
      initType: 'wx',
      autoGetCurExternal: false,
      debug: false,
      isUseEncode: false
    };
    this.idmapping = false;
    /**
     *
     * @param {*配置信息} config
     * @description 通过接口，获取微信sdk签名配置
     */
    this.getJsSdkSignConfig = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(prams) {
        var signUrl, ticketType, _this$baseConfig, corpId, agentId, _this$baseConfig$acco, account, appId, mode, message, _this$baseConfig$comp, companyId, _window, href, _href$split, res, url, wxConfig, accId, _res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              signUrl = prams.signUrl, ticketType = prams.ticketType;
              _this$baseConfig = _this.baseConfig, corpId = _this$baseConfig.corpId, agentId = _this$baseConfig.agentId, _this$baseConfig$acco = _this$baseConfig.account, account = _this$baseConfig$acco === void 0 ? '' : _this$baseConfig$acco, appId = _this$baseConfig.appId, mode = _this$baseConfig.mode, message = _this$baseConfig.message, _this$baseConfig$comp = _this$baseConfig.companyId, companyId = _this$baseConfig$comp === void 0 ? '' : _this$baseConfig$comp; // 如果没有传入signUrl，
              if (!signUrl) {
                // 获取session中registerWxSdkUrl，适配history模式下，ios分享bug
                // registerWxSdkUrl值：在页面授权完成后保存（安卓不用）
                signUrl = window.sessionStorage.getItem('registerWxSdkUrl') || '';
                // 如果当前机型不是ios或者signUrl没值
                if (!isIOS || !signUrl || mode === 'hash') {
                  _window = window, href = _window.location.href;
                  _href$split = href.split('#');
                  signUrl = _href$split[0];
                }
              }
              signUrl = encodeURIComponent(signUrl);
              res = null;
              url = getReqUrl(isQw || ticketType ? 'qw' : 'wx');
              wxConfig = {
                agent: undefined,
                corp: undefined,
                traceId: ''
              };
              accId = account || companyId;
              if (!(isQw || ticketType)) {
                _context.next = 18;
                break;
              }
              _context.next = 11;
              return $jsdkHttp({
                method: 'get',
                url: url,
                params: {
                  signUrl: signUrl,
                  agentId: agentId || '',
                  corpId: corpId || '',
                  ticketType: ticketType || '',
                  account: accId,
                  companyId: accId
                }
              });
            case 11:
              res = _context.sent;
              _this.idmapping = res.data.idmapping;
              _this.baseConfig.opencorpid = res.data.opencorpid;
              wxConfig.agent = _extends({}, res.data.agent, {
                appId: appId || _this.baseConfig.corpId
              });
              wxConfig.corp = _extends({}, res.data.corp, {
                appId: appId || _this.baseConfig.corpId
              });
              _context.next = 22;
              break;
            case 18:
              _context.next = 20;
              return $jsdkHttp({
                method: 'get',
                url: url,
                params: {
                  signUrl: signUrl,
                  companyId: account || '',
                  appId: appId || ''
                }
              });
            case 20:
              res = _context.sent;
              wxConfig.corp = res.data;
            case 22:
              if (!(res && res.success)) {
                _context.next = 25;
                break;
              }
              wxConfig.traceId = (_res = res) == null ? void 0 : _res.traceId;
              return _context.abrupt("return", wxConfig);
            case 25:
              // 上报异常日志
              try {
                _this.sendErrorSpm && _this.sendErrorSpm({
                  code: 500500,
                  message: 'SDK-获取签名调用',
                  data: res
                });
              } catch (error) {
                // do nothing
              }
              message && message('获取签名失败');
              console.log('【获取微信jssdk参数的】接口调用失败: ');
              return _context.abrupt("return");
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    this.baseConfig = _extends({}, this.baseConfig, config);
  }
  // 必须使用getInstance方法创建对象
  CfxJsSdkInit.getInstance = function getInstance(config) {
    return new CfxJsSdkInit(config);
  };
  var _proto = CfxJsSdkInit.prototype;
  // 验证wx.ready
  _proto.getReadyCallBack = function getReadyCallBack() {
    var _this2 = this;
    var _window2 = window,
      wx = _window2.wx;
    var message = this.baseConfig.message;
    return new Promise(function (resolve, reject) {
      // 页面加载完成后用户就有可能调用微信的分享，所以当页面ready 完后就加载
      wx.ready( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              resolve(true);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })));
      // 微信预加载失败回调
      wx.error(function (res) {
        message && message(res.errMsg + "---\u5FAE\u4FE1sdk\u6CE8\u518C\u5931\u8D25");
        _this2.sendErrorSpm && _this2.sendErrorSpm({
          code: 500500,
          message: 'SDK-微信SDK注册失败',
          data: res
        });
        // 当使用微信开发者工具调试本地代码时，可以不抛出异常来阻断后续的逻辑执行，因为此处失败的情况下，微信开发者工具内部还是可以正常调用api的
        if (window.location.href.startsWith('http:')) {
          resolve(true);
        } else {
          reject(res.errMsg + "---\u5FAE\u4FE1sdk\u6CE8\u518C\u5931\u8D25");
        }
      });
    });
  }
  // 处理agentConfig
  ;
  _proto.setAgentConfig =
  /*#__PURE__*/
  function () {
    var _setAgentConfig = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
      var _this3 = this;
      var _traceId, idmapping, _window3, wx, _this$baseConfig2, corpId, opencorpid, agentId, autoGetCurExternal, message, sid, wxConfig, res, config;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            console.log('params: ', params);
            _traceId = params.traceId;
            idmapping = this.idmapping;
            _window3 = window, wx = _window3.wx;
            _this$baseConfig2 = this.baseConfig, corpId = _this$baseConfig2.corpId, opencorpid = _this$baseConfig2.opencorpid, agentId = _this$baseConfig2.agentId, autoGetCurExternal = _this$baseConfig2.autoGetCurExternal, message = _this$baseConfig2.message, sid = _this$baseConfig2.sid;
            wxConfig = params.wxConfig;
            if (!isMicromessenger) {
              _context4.next = 9;
              break;
            }
            _context4.next = 9;
            return this.getReadyCallBack();
          case 9:
            if (wxConfig) {
              _context4.next = 15;
              break;
            }
            _context4.next = 12;
            return this.getJsSdkSignConfig({
              ticketType: 'agent_config'
            });
          case 12:
            res = _context4.sent;
            wxConfig = res == null ? void 0 : res.agent;
            _traceId = res == null ? void 0 : res.traceId;
          case 15:
            config = _extends({
              corpid: opencorpid || corpId,
              agentid: agentId
            }, wxConfig, {
              jsApiList: params.jsApiList || []
            });
            if (!wx.agentConfig) {
              _context4.next = 20;
              break;
            }
            return _context4.abrupt("return", new Promise(function (resolve, reject) {
              wx.agentConfig(_extends({}, config, {
                success: function success(res) {
                  console.log('res: ', res);
                  window.wxScrmJsdk = 'success';
                  if (isWxwork && autoGetCurExternal) {
                    // 这一块后期会删除，暂时保留
                    wx.invoke('getCurExternalContact', {}, /*#__PURE__*/function () {
                      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(wxres) {
                        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                          while (1) switch (_context3.prev = _context3.next) {
                            case 0:
                              if (!(wxres.err_msg === 'getCurExternalContact:ok')) {
                                _context3.next = 5;
                                break;
                              }
                              _context3.next = 3;
                              return getIdmapping({
                                corpid: corpId || '',
                                ids: wxres.userId ? [wxres.userId] : [],
                                id_type: 'external',
                                to_open: false,
                                sid: sid
                              }, idmapping);
                            case 3:
                              window.wxExternalUserid = _context3.sent;
                              // 通知客服页面 userId 已存在
                              window.wxKfInfo && (window.wxKfInfo.hasWxUserId = true);
                            case 5:
                            case "end":
                              return _context3.stop();
                          }
                        }, _callee3);
                      }));
                      return function (_x3) {
                        return _ref3.apply(this, arguments);
                      };
                    }());
                    wx.invoke('getCurExternalChat', {}, function (wxres) {
                      if (wxres.err_msg === 'getCurExternalChat:ok') {
                        window.wxExternalChatid = wxres.chatId || '';
                      }
                    });
                  }
                  // 回调
                  resolve(true);
                },
                fail: function fail(res) {
                  console.log('res: ', res);
                  // 异常日志上报
                  try {
                    _this3.sendErrorSpm && _this3.sendErrorSpm({
                      code: 500500,
                      message: 'SDK-企微agentConfig失败',
                      data: res,
                      config: config,
                      traceId: _traceId
                    });
                  } catch (error) {
                    // do nothing
                  }
                  window.wxScrmJsdk = 'jsdk-fail';
                  if (res.errMsg.indexOf('function not exist') > -1) {
                    console.log('版本过低请升级');
                  }
                  message && message(res.errMsg + "---wx.agentConfig");
                  reject(res.errMsg + "---wx.agentConfig");
                }
              }));
            }));
          case 20:
            window.wxScrmJsdk = 'agent-fail';
            this.sendErrorSpm({
              code: 500500,
              message: 'SDK-未找到wx.agentConfig方法'
            });
            return _context4.abrupt("return", Promise.reject('未找到wx.agentConfig方法'));
          case 23:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function setAgentConfig(_x2) {
      return _setAgentConfig.apply(this, arguments);
    }
    return setAgentConfig;
  }()
  /**
   * 微信分享config
   */
  ;
  _proto.setWxShareConfig = function setWxShareConfig(wxConfig) {
    var _window4 = window,
      wx = _window4.wx;
    var _this$baseConfig3 = this.baseConfig,
      debug = _this$baseConfig3.debug,
      registerJsApiList = _this$baseConfig3.registerJsApiList,
      openTagList = _this$baseConfig3.openTagList;
    var jsApiList = Array.from(new Set([].concat(wxShareConfig, registerJsApiList || [], openTagList || [])));
    wx.config(_extends({
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      debug: debug,
      // 必填，需要使用的JS接口列表
      jsApiList: jsApiList,
      // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      openTagList: openTagList || []
    }, wxConfig.corp));
    // 必须放在 回调函数里，不然当在注册的时候 ，有可能还没有返回数据回来，例如刷新问题
    // 微信检查接口列表
    wx.checkJsApi({
      // 需要检测的JS接口列表
      jsApiList: jsApiList,
      // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      openTagList: openTagList || [],
      success: function success(res) {
        console.log('wx.checkJsApi:success ', res);
        // 以键值对的形式返回，可用的api值true，不可用为false
      }
    });

    return this.setAgentConfig({
      wxConfig: wxConfig.agent,
      traceId: wxConfig.traceId
    });
  };
  /**
   * 企微分享config
   */
  _proto.setQwWxShareConfig = function setQwWxShareConfig(wxConfig) {
    var _window5 = window,
      wx = _window5.wx;
    var _this$baseConfig4 = this.baseConfig,
      debug = _this$baseConfig4.debug,
      registerJsApiList = _this$baseConfig4.registerJsApiList;
    var jsApiList = Array.from(new Set([].concat(qwShareConfig, registerJsApiList || [])));
    wx.config(_extends({
      beta: true,
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      debug: debug,
      // 必填，需要使用的JS接口列表
      jsApiList: jsApiList
    }, wxConfig.corp));
    // 必须放在 回调函数里，不然当在注册的时候 ，有可能还没有返回数据回来，例如刷新问题
    // 微信检查接口列表
    wx.checkJsApi({
      // 需要检测的JS接口列表
      jsApiList: jsApiList,
      success: function success(res) {
        console.log('wx.checkJsApi:success ', res);
        // 以键值对的形式返回，可用的api值true，不可用为false
      }
    });

    return this.setAgentConfig({
      wxConfig: wxConfig.agent,
      jsApiList: jsApiList,
      traceId: wxConfig.traceId
    });
  };
  /**
   * 设置个微分享配置
   */
  _proto.setWxShare =
  /*#__PURE__*/
  function () {
    var _setWxShare = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(shareData, callBack) {
      var _window6, wx, sdkUrl, version, isNewVersionSdk;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _window6 = window, wx = _window6.wx;
            sdkUrl = this.baseConfig.sdkUrl;
            _context5.next = 4;
            return this.getReadyCallBack();
          case 4:
            // 判断是否为新版本的sdk
            version = (sdkUrl == null ? void 0 : sdkUrl.split('jweixin-')[1]) || [];
            isNewVersionSdk = Number(version[0]) >= 2 || Number(version[2]) >= 4;
            if (isNewVersionSdk) {
              // ===========【新版本】===========
              // 分享给好友
              wx.updateAppMessageShareData(_extends({}, shareData, {
                success: function success() {
                  // 【设置】：分享好友成功回调
                  // '新版本：【设置】分享给好友【成功】';
                  callBack(true, 'friend');
                },
                cancel: function cancel() {
                  // '新版本：【设置】分享给好友【失败】';
                  callBack(false, 'friend');
                }
              }));
              // 分享到朋友圈
              wx.updateTimelineShareData(_extends({}, shareData, {
                success: function success() {
                  // 【设置】：分享给朋友圈成功回调
                  // '新版本：【设置】分享到朋友圈【成功】';
                  // 调用传进来的回调函数
                  callBack(true, 'friendCircle');
                },
                cancel: function cancel() {
                  // '新版本：【设置】分享到朋友圈【失败】';
                  // 调用传进来的回调函数
                  callBack(false, 'friendCircle');
                }
              }));
            } else {
              // ===========【旧版本】===========
              // 分享给朋友
              wx.onMenuShareAppMessage(_extends({}, shareData, {
                success: function success() {
                  // 用户点击了分享后执行的回调函数
                  // '旧版本：分享给朋友【成功】');
                  // 调用传进来的回调函数
                  callBack(true, 'friend');
                },
                cancel: function cancel() {
                  // '旧版本：【取消】分享给朋友';
                  // 调用传进来的回调函数
                  callBack(false, 'friend');
                }
              }));
              // 分享到朋友圈
              wx.onMenuShareTimeline(_extends({}, shareData, {
                success: function success() {
                  // 用户点击了分享后执行的回调函数
                  // '旧版本：分享到朋友圈【成功】';
                  // 调用传进来的回调函数
                  callBack(true, 'friendCircle');
                },
                cancel: function cancel() {
                  // '旧版本：【取消】分享到朋友圈';
                  callBack(false, 'friendCircle');
                }
              }));
            }
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function setWxShare(_x4, _x5) {
      return _setWxShare.apply(this, arguments);
    }
    return setWxShare;
  }();
  /**
   * 设置企微分享配置
   */
  _proto.setQwWxShare =
  /*#__PURE__*/
  function () {
    var _setQwWxShare = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(shareData, callBack) {
      var _window7, wx;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _window7 = window, wx = _window7.wx;
            _context6.next = 3;
            return this.getReadyCallBack();
          case 3:
            // 【转发】转发会发送至企微环境下 或者 外部联系人 不需要根据view做判断 因为在进入项目时 企微环境下会默认开启预览模式
            wx.onMenuShareAppMessage(_extends({}, shareData, {
              success: function success() {
                // 用户确认分享后执行的回调函数
                // 调用传进来的回调函数
                callBack(true, 'friend');
              },
              cancel: function cancel() {
                // 用户取消分享后执行的回调函数
                // 调用传进来的回调函数
                callBack(false, 'friend');
              }
            }));
            // 发送至【微信朋友】链接
            wx.onMenuShareWechat(_extends({}, shareData, {
              success: function success() {
                // 用户确认分享后执行的回调函数
                callBack(true, 'friend');
              },
              cancel: function cancel() {
                // 用户取消分享后执行的回调函数
                callBack(false, 'friend');
              }
            }));
            // 分享至朋友圈
            wx.onMenuShareTimeline(_extends({}, shareData, {
              success: function success() {
                // 用户确认分享后执行的回调函数
                callBack(true, 'friendCircle');
              },
              cancel: function cancel() {
                // 用户取消分享后执行的回调函数
                callBack(false, 'friendCircle');
              }
            }));
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function setQwWxShare(_x6, _x7) {
      return _setQwWxShare.apply(this, arguments);
    }
    return setQwWxShare;
  }();
  /**
   * 设置jsSDK
   */
  _proto.setQwJsSDK =
  /*#__PURE__*/
  function () {
    var _setQwJsSDK = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(wxConfig) {
      var _window8, wx, _this$baseConfig5, verifyJsApiList, debug, registerJsApiList, configData;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _window8 = window, wx = _window8.wx;
            _this$baseConfig5 = this.baseConfig, verifyJsApiList = _this$baseConfig5.verifyJsApiList, debug = _this$baseConfig5.debug, registerJsApiList = _this$baseConfig5.registerJsApiList;
            configData = _extends({
              beta: true,
              debug: debug
            }, wxConfig.corp, {
              jsApiList: Array.from(new Set([].concat(qwRegisterJsApiList, registerJsApiList || [])))
            });
            wx.config(configData);
            return _context7.abrupt("return", this.setAgentConfig({
              wxConfig: wxConfig.agent,
              jsApiList: Array.from(new Set([].concat(qwVerifyJsApiList, verifyJsApiList || []))),
              traceId: wxConfig.traceId
            }));
          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
    function setQwJsSDK(_x8) {
      return _setQwJsSDK.apply(this, arguments);
    }
    return setQwJsSDK;
  }();
  // 企微/个微调用界面分享
  _proto.initShare =
  /*#__PURE__*/
  function () {
    var _initShare = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(shareData, config) {
      var handleCallBack, _this$baseConfig6, hideMenuList, showMenuList;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (config === void 0) {
              config = {};
            }
            _context8.prev = 1;
            handleCallBack = function handleCallBack(success, type) {
              if (typeof config.callBack === 'function') {
                config.callBack({
                  success: success,
                  type: type,
                  shareData: shareData
                });
              }
            }; // 注册config
            _context8.next = 5;
            return this.initShareSDK(config.signUrl);
          case 5:
            if (!isWx) {
              _context8.next = 10;
              break;
            }
            _context8.next = 8;
            return this.setWxShare(shareData, handleCallBack);
          case 8:
            _context8.next = 12;
            break;
          case 10:
            _context8.next = 12;
            return this.setQwWxShare(shareData, handleCallBack);
          case 12:
            // 显示所有按钮
            // this.showShareMenu();
            _this$baseConfig6 = this.baseConfig, hideMenuList = _this$baseConfig6.hideMenuList, showMenuList = _this$baseConfig6.showMenuList; // 需要显示的菜单
            this.showMenu(showMenuList || []);
            // 需要影藏的菜单
            this.hideMenu(hideMenuList || []);
            // 执行队列
            this.handlePendingList();
            // 执行后面的逻辑：分享等
            _context8.next = 21;
            break;
          case 18:
            _context8.prev = 18;
            _context8.t0 = _context8["catch"](1);
            console.log('err: ', _context8.t0);
          case 21:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this, [[1, 18]]);
    }));
    function initShare(_x9, _x10) {
      return _initShare.apply(this, arguments);
    }
    return initShare;
  }();
  // 企微/个微分享config注册
  _proto.initShareSDK =
  /*#__PURE__*/
  function () {
    var _initShareSDK = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(signUrl) {
      var _this$baseConfig7, message, sdkUrl, wxConfig;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _this$baseConfig7 = this.baseConfig, message = _this$baseConfig7.message, sdkUrl = _this$baseConfig7.sdkUrl; // 获取微信sdkjs
            _context9.prev = 1;
            _context9.next = 4;
            return setLoadWxSdk(sdkUrl);
          case 4:
            _context9.next = 11;
            break;
          case 6:
            _context9.prev = 6;
            _context9.t0 = _context9["catch"](1);
            console.log('error: ', _context9.t0);
            message && message('微信sdk加载失败');
            return _context9.abrupt("return");
          case 11:
            _context9.prev = 11;
            _context9.next = 14;
            return this.getJsSdkSignConfig({
              signUrl: signUrl || ''
            });
          case 14:
            _context9.t1 = _context9.sent;
            if (_context9.t1) {
              _context9.next = 17;
              break;
            }
            _context9.t1 = {};
          case 17:
            wxConfig = _context9.t1;
            if (isMicromessenger) {
              _context9.next = 23;
              break;
            }
            _context9.next = 21;
            return this.setAgentConfig({
              wxConfig: wxConfig == null ? void 0 : wxConfig.agent,
              traceId: wxConfig == null ? void 0 : wxConfig.traceId
            });
          case 21:
            _context9.next = 30;
            break;
          case 23:
            if (!isWx) {
              _context9.next = 28;
              break;
            }
            _context9.next = 26;
            return this.setWxShareConfig(wxConfig);
          case 26:
            _context9.next = 30;
            break;
          case 28:
            _context9.next = 30;
            return this.setQwWxShareConfig(wxConfig);
          case 30:
            _context9.next = 35;
            break;
          case 32:
            _context9.prev = 32;
            _context9.t2 = _context9["catch"](11);
            console.log('error: ', _context9.t2);
          case 35:
          case "end":
            return _context9.stop();
        }
      }, _callee9, this, [[1, 6], [11, 32]]);
    }));
    function initShareSDK(_x11) {
      return _initShareSDK.apply(this, arguments);
    }
    return initShareSDK;
  }();
  /**
  * 异常上报
  * @param msg 异常信息
  */
  _proto.sendErrorSpm =
  /*#__PURE__*/
  function () {
    var _sendErrorSpm = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(msg) {
      var _window9, _window9$wx, _window10, _window10$wx, _parent, _parent$window, _parent$window$wx, _parent2, _parent2$window, _parent2$window$wx, _window11, _window11$Monitor, _msg;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            try {
              _msg = msg || {}; // 看看wx.config wx.agentConfig是否存在
              _msg.wxData = {
                'config': Boolean((_window9 = window) == null ? void 0 : (_window9$wx = _window9.wx) == null ? void 0 : _window9$wx.config),
                'agentConfig': Boolean((_window10 = window) == null ? void 0 : (_window10$wx = _window10.wx) == null ? void 0 : _window10$wx.agentConfig),
                'parent.config': Boolean((_parent = parent) == null ? void 0 : (_parent$window = _parent.window) == null ? void 0 : (_parent$window$wx = _parent$window.wx) == null ? void 0 : _parent$window$wx.config),
                'parent.agentConfig': Boolean((_parent2 = parent) == null ? void 0 : (_parent2$window = _parent2.window) == null ? void 0 : (_parent2$window$wx = _parent2$window.wx) == null ? void 0 : _parent2$window$wx.agentConfig)
              };
              (_window11 = window) == null ? void 0 : (_window11$Monitor = _window11.Monitor) == null ? void 0 : _window11$Monitor.sendCustomError({
                message: JSON.stringify(_msg)
              });
            } catch (error) {
              // do nothing
            }
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    function sendErrorSpm(_x12) {
      return _sendErrorSpm.apply(this, arguments);
    }
    return sendErrorSpm;
  }();
  // 初始化企微sdk
  _proto.initQwJsSDK =
  /*#__PURE__*/
  function () {
    var _initQwJsSDK = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(signUrl) {
      var _this4 = this;
      var _this$baseConfig8, hideMenuList, showMenuList, agentId, corpId, message, sdkUrl, sid, wxConfig, _window12, wx, fun, openEnterpriseChat;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            // 校验企微版本并且提示
            if (isLowWxworkVersion()) showMessage();
            _this$baseConfig8 = this.baseConfig, hideMenuList = _this$baseConfig8.hideMenuList, showMenuList = _this$baseConfig8.showMenuList, agentId = _this$baseConfig8.agentId, corpId = _this$baseConfig8.corpId, message = _this$baseConfig8.message, sdkUrl = _this$baseConfig8.sdkUrl, sid = _this$baseConfig8.sid; // 获取微信sdkjs
            _context15.prev = 2;
            _context15.next = 5;
            return setLoadWxSdk(sdkUrl);
          case 5:
            _context15.next = 12;
            break;
          case 7:
            _context15.prev = 7;
            _context15.t0 = _context15["catch"](2);
            message && message('微信sdk加载失败');
            this.sendErrorSpm({
              code: 500500,
              message: 'SDK-微信sdk加载失败'
            });
            return _context15.abrupt("return");
          case 12:
            if (!(!agentId || !corpId)) {
              _context15.next = 16;
              break;
            }
            console.info('无agentId或者corpId，跳过sdk初始化');
            this.sendErrorSpm({
              code: 500500,
              message: 'SDK-无agentId或者corpId，跳过sdk初始化'
            });
            return _context15.abrupt("return");
          case 16:
            _context15.prev = 16;
            _context15.next = 19;
            return this.getJsSdkSignConfig({
              signUrl: signUrl || ''
            });
          case 19:
            wxConfig = _context15.sent;
            _context15.next = 22;
            return this.setQwJsSDK(wxConfig);
          case 22:
            // 显示所有按钮
            // this.showShareMenu();
            // 需要显示的菜单
            this.showMenu(showMenuList || []);
            // 需要影藏的菜单
            this.hideMenu(hideMenuList || []);
            // 执行队列
            this.handlePendingList();
            // 我们可以在这里取重新wx.invoke
            _window12 = window, wx = _window12.wx;
            fun = wx.invoke; // 需要对企微wx.invoke进行处理
            if (window.wx.openEnterpriseChat) {
              openEnterpriseChat = window.wx.openEnterpriseChat;
              window.wx.openEnterpriseChat = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(params) {
                  var reParams, reUserIds, userIds, reExternalUserIds, externalUserIds;
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        reParams = _extends({}, params);
                        if (!reParams.userIds) {
                          _context11.next = 7;
                          break;
                        }
                        reUserIds = reParams.userIds.split(';');
                        _context11.next = 5;
                        return getIdmapping({
                          corpid: corpId || '',
                          ids: reUserIds,
                          id_type: 'user',
                          to_open: true,
                          sid: sid
                        }, _this4.idmapping);
                      case 5:
                        userIds = _context11.sent;
                        // wxres.userId || '';
                        reParams.userIds = userIds;
                      case 7:
                        if (!reParams.externalUserIds) {
                          _context11.next = 13;
                          break;
                        }
                        reExternalUserIds = reParams.externalUserIds.split(';');
                        _context11.next = 11;
                        return getIdmapping({
                          corpid: corpId || '',
                          ids: reExternalUserIds,
                          id_type: 'external',
                          to_open: true,
                          sid: sid
                        }, _this4.idmapping);
                      case 11:
                        externalUserIds = _context11.sent;
                        reParams.externalUserIds = externalUserIds;
                      case 13:
                        openEnterpriseChat(reParams);
                      case 14:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x14) {
                  return _ref4.apply(this, arguments);
                };
              }();
            }
            window.wx.invoke = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
              var _len,
                arr,
                _key,
                list,
                event,
                cb,
                params,
                reqParams,
                selectedUserIds,
                _args14 = arguments;
              return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                while (1) switch (_context14.prev = _context14.next) {
                  case 0:
                    for (_len = _args14.length, arr = new Array(_len), _key = 0; _key < _len; _key++) {
                      arr[_key] = _args14[_key];
                    }
                    // const { corpId } = this.baseConfig;
                    list = [].concat(arr); // 做出逻辑处理
                    event = list[0];
                    cb = list[2];
                    if (event === 'getCurExternalContact') {
                      list[2] = /*#__PURE__*/function () {
                        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(res) {
                          var result;
                          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                            while (1) switch (_context12.prev = _context12.next) {
                              case 0:
                                result = _extends({}, res);
                                if (!(res.err_msg === 'getCurExternalContact:ok')) {
                                  _context12.next = 5;
                                  break;
                                }
                                _context12.next = 4;
                                return getIdmapping({
                                  corpid: corpId || '',
                                  ids: result.userId ? [result.userId] : [],
                                  id_type: 'external',
                                  to_open: false,
                                  sid: sid
                                }, _this4.idmapping);
                              case 4:
                                result.userId = _context12.sent;
                              case 5:
                                cb && cb(result);
                              case 6:
                              case "end":
                                return _context12.stop();
                            }
                          }, _callee12);
                        }));
                        return function (_x15) {
                          return _ref6.apply(this, arguments);
                        };
                      }();
                    }
                    if (!(event === 'openUserProfile')) {
                      _context14.next = 11;
                      break;
                    }
                    params = _extends({}, list[1]);
                    _context14.next = 9;
                    return getIdmapping({
                      corpid: corpId || '',
                      ids: params.userid ? [params.userid] : [],
                      id_type: params.type === 1 ? 'user' : 'external',
                      to_open: true,
                      sid: sid
                    }, _this4.idmapping);
                  case 9:
                    params.userid = _context14.sent;
                    list[1] = params;
                  case 11:
                    if (!(event === 'selectEnterpriseContact')) {
                      _context14.next = 20;
                      break;
                    }
                    // 转换请求参数
                    reqParams = _extends({}, list[1]);
                    selectedUserIds = reqParams.selectedUserIds; // 传了参数就去转换
                    if (!selectedUserIds) {
                      _context14.next = 18;
                      break;
                    }
                    _context14.next = 17;
                    return getIdmapping({
                      corpid: corpId || '',
                      ids: selectedUserIds ? [selectedUserIds] : [],
                      id_type: 'user',
                      to_open: true,
                      sid: sid
                    }, _this4.idmapping, false);
                  case 17:
                    reqParams.selectedUserIds = _context14.sent;
                  case 18:
                    list[1] = reqParams;
                    // 转换拿到的参数
                    list[2] = /*#__PURE__*/function () {
                      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(res) {
                        var _res$result$userList, userIds, replacedIds;
                        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                          while (1) switch (_context13.prev = _context13.next) {
                            case 0:
                              if (!(res.err_msg === 'selectEnterpriseContact:ok')) {
                                _context13.next = 7;
                                break;
                              }
                              if (typeof res.result === 'string') res.result = JSON.parse(res.result);
                              userIds = (_res$result$userList = res.result.userList) == null ? void 0 : _res$result$userList.map(function (item) {
                                return item.id;
                              });
                              _context13.next = 5;
                              return getIdmapping({
                                corpid: corpId || '',
                                ids: userIds ? [].concat(userIds) : [],
                                id_type: 'user',
                                to_open: false,
                                sid: sid
                              }, _this4.idmapping, false);
                            case 5:
                              replacedIds = _context13.sent;
                              res.result.userList.forEach(function (item, index) {
                                item.id = replacedIds[index];
                              });
                            case 7:
                              cb && cb(res);
                            case 8:
                            case "end":
                              return _context13.stop();
                          }
                        }, _callee13);
                      }));
                      return function (_x16) {
                        return _ref7.apply(this, arguments);
                      };
                    }();
                  case 20:
                    fun.apply(void 0, list);
                  case 21:
                  case "end":
                    return _context14.stop();
                }
              }, _callee14);
            }));
            _context15.next = 34;
            break;
          case 31:
            _context15.prev = 31;
            _context15.t1 = _context15["catch"](16);
            message && message('更新企微方法失败');
          case 34:
          case "end":
            return _context15.stop();
        }
      }, _callee15, this, [[2, 7], [16, 31]]);
    }));
    function initQwJsSDK(_x13) {
      return _initQwJsSDK.apply(this, arguments);
    }
    return initQwJsSDK;
  }();
  // 初始化个微SDK
  _proto.initWxJsSDK =
  /*#__PURE__*/
  function () {
    var _initWxJsSDK = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(signUrl) {
      var _this$baseConfig9, message, sdkUrl, wxConfig, _this$baseConfig10, debug, registerJsApiList, openTagList, jsApiList, _this$baseConfig11, hideMenuList, showMenuList;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            _this$baseConfig9 = this.baseConfig, message = _this$baseConfig9.message, sdkUrl = _this$baseConfig9.sdkUrl; // 获取微信sdkjs
            _context16.prev = 1;
            _context16.next = 4;
            return setLoadWxSdk(sdkUrl);
          case 4:
            _context16.next = 10;
            break;
          case 6:
            _context16.prev = 6;
            _context16.t0 = _context16["catch"](1);
            message && message('微信sdk加载失败');
            return _context16.abrupt("return");
          case 10:
            _context16.next = 12;
            return this.getJsSdkSignConfig({
              signUrl: signUrl || ''
            });
          case 12:
            _context16.t1 = _context16.sent;
            if (_context16.t1) {
              _context16.next = 15;
              break;
            }
            _context16.t1 = {};
          case 15:
            wxConfig = _context16.t1;
            if (window.wx) {
              _context16.next = 18;
              break;
            }
            return _context16.abrupt("return");
          case 18:
            _this$baseConfig10 = this.baseConfig, debug = _this$baseConfig10.debug, registerJsApiList = _this$baseConfig10.registerJsApiList, openTagList = _this$baseConfig10.openTagList;
            jsApiList = Array.from(new Set([].concat(wxShareConfig, registerJsApiList || [], openTagList || [])));
            window.wx.config(_extends({
              debug: debug,
              jsApiList: jsApiList,
              openTagList: openTagList || []
            }, wxConfig.corp));
            // 必须放在 回调函数里，不然当在注册的时候 ，有可能还没有返回数据回来，例如刷新问题
            // 微信检查接口列表
            window.wx.checkJsApi({
              jsApiList: jsApiList,
              // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
              openTagList: openTagList || [],
              success: function success(res) {
                // 以键值对的形式返回，可用的api值true，不可用为false
                console.log('wx.checkJsApi:success ', res);
              }
            });
            // 等待wx.ready完成
            _context16.next = 24;
            return this.getReadyCallBack();
          case 24:
            _this$baseConfig11 = this.baseConfig, hideMenuList = _this$baseConfig11.hideMenuList, showMenuList = _this$baseConfig11.showMenuList;
            window.wx.ready(function () {
              // 需要显示的菜单
              window.wx.showMenuItems({
                menuList: showMenuList || []
              });
              // 需要影藏的菜单
              window.wx.hideMenuItems({
                menuList: hideMenuList || []
              });
            });
          case 26:
          case "end":
            return _context16.stop();
        }
      }, _callee16, this, [[1, 6]]);
    }));
    function initWxJsSDK(_x17) {
      return _initWxJsSDK.apply(this, arguments);
    }
    return initWxJsSDK;
  }() // 统一初始化方法
  ;
  _proto.initWxConfig =
  /*#__PURE__*/
  function () {
    var _initWxConfig = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(signUrl) {
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            if (!isQw) {
              _context17.next = 6;
              break;
            }
            _context17.next = 4;
            return this.initQwJsSDK(signUrl);
          case 4:
            _context17.next = 9;
            break;
          case 6:
            if (!isWx) {
              _context17.next = 9;
              break;
            }
            _context17.next = 9;
            return this.initWxJsSDK(signUrl);
          case 9:
            _context17.next = 14;
            break;
          case 11:
            _context17.prev = 11;
            _context17.t0 = _context17["catch"](0);
            console.log('error: ', _context17.t0);
          case 14:
          case "end":
            return _context17.stop();
        }
      }, _callee17, this, [[0, 11]]);
    }));
    function initWxConfig(_x18) {
      return _initWxConfig.apply(this, arguments);
    }
    return initWxConfig;
  }() // 显示说有可屏蔽菜单
  ;
  _proto.showShareMenu =
  /*#__PURE__*/
  function () {
    var _showShareMenu = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
      var _this5 = this;
      var _window13, wx;
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            _window13 = window, wx = _window13.wx;
            if (wx.ready) {
              _context18.next = 3;
              break;
            }
            return _context18.abrupt("return", this.sdkPendingList.push(function () {
              _this5.showShareMenu();
            }));
          case 3:
            _context18.next = 5;
            return this.getReadyCallBack();
          case 5:
            setTimeout(function () {
              wx.showMenuItems({
                menuList: [].concat(shareList)
              });
            }, 500);
          case 6:
          case "end":
            return _context18.stop();
        }
      }, _callee18, this);
    }));
    function showShareMenu() {
      return _showShareMenu.apply(this, arguments);
    }
    return showShareMenu;
  }();
  // 屏蔽所有可屏蔽菜单
  _proto.hideShareMenu =
  /*#__PURE__*/
  function () {
    var _hideShareMenu = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
      var _this6 = this;
      var _window14, wx;
      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            _window14 = window, wx = _window14.wx;
            if (wx.ready) {
              _context19.next = 3;
              break;
            }
            return _context19.abrupt("return", this.sdkPendingList.push(function () {
              _this6.hideShareMenu();
            }));
          case 3:
            _context19.next = 5;
            return this.getReadyCallBack();
          case 5:
            setTimeout(function () {
              wx.hideMenuItems({
                menuList: [].concat(shareList, shareCopyList)
              });
            }, 500);
          case 6:
          case "end":
            return _context19.stop();
        }
      }, _callee19, this);
    }));
    function hideShareMenu() {
      return _hideShareMenu.apply(this, arguments);
    }
    return hideShareMenu;
  }();
  // 隐藏菜单内容（menuList）
  _proto.hideMenu =
  /*#__PURE__*/
  function () {
    var _hideMenu = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(menuList, defer) {
      var _this7 = this;
      var _window15, wx;
      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            if (defer === void 0) {
              defer = 500;
            }
            _window15 = window, wx = _window15.wx;
            if (wx.ready) {
              _context20.next = 4;
              break;
            }
            return _context20.abrupt("return", this.sdkPendingList.push(function () {
              _this7.hideMenu(menuList, defer);
            }));
          case 4:
            _context20.next = 6;
            return this.getReadyCallBack();
          case 6:
            setTimeout(function () {
              wx.hideMenuItems({
                menuList: [].concat(menuList)
              });
            }, defer);
          case 7:
          case "end":
            return _context20.stop();
        }
      }, _callee20, this);
    }));
    function hideMenu(_x19, _x20) {
      return _hideMenu.apply(this, arguments);
    }
    return hideMenu;
  }();
  // 显示菜单内容
  _proto.showMenu =
  /*#__PURE__*/
  function () {
    var _showMenu = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(menuList, defer) {
      var _this8 = this;
      var _window16, wx;
      return _regeneratorRuntime().wrap(function _callee21$(_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            if (defer === void 0) {
              defer = 500;
            }
            _window16 = window, wx = _window16.wx;
            if (wx.ready) {
              _context21.next = 4;
              break;
            }
            return _context21.abrupt("return", this.sdkPendingList.push(function () {
              _this8.showMenu(menuList, defer);
            }));
          case 4:
            _context21.next = 6;
            return this.getReadyCallBack();
          case 6:
            setTimeout(function () {
              wx.showMenuItems({
                menuList: [].concat(menuList)
              });
            }, defer);
          case 7:
          case "end":
            return _context21.stop();
        }
      }, _callee21, this);
    }));
    function showMenu(_x21, _x22) {
      return _showMenu.apply(this, arguments);
    }
    return showMenu;
  }();
  // 隐藏复制按钮
  _proto.hideBasicMenu =
  /*#__PURE__*/
  function () {
    var _hideBasicMenu = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
      var _this9 = this;
      var _window17, wx;
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) switch (_context22.prev = _context22.next) {
          case 0:
            _window17 = window, wx = _window17.wx;
            if (window.wx.ready) {
              _context22.next = 3;
              break;
            }
            return _context22.abrupt("return", this.sdkPendingList.push(function () {
              _this9.hideBasicMenu();
            }));
          case 3:
            _context22.next = 5;
            return this.getReadyCallBack();
          case 5:
            wx.ready(function () {
              setTimeout(function () {
                wx.hideMenuItems({
                  menuList: [].concat(shareCopyList)
                });
              }, 500);
            });
          case 6:
          case "end":
            return _context22.stop();
        }
      }, _callee22, this);
    }));
    function hideBasicMenu() {
      return _hideBasicMenu.apply(this, arguments);
    }
    return hideBasicMenu;
  }();
  // 设置sdk缓冲队列
  _proto.handlePendingList = function handlePendingList() {
    while (this.sdkPendingList.length) {
      var fun = this.sdkPendingList.shift();
      typeof fun === 'function' && fun();
    }
  };
  return CfxJsSdkInit;
}();
CfxJsSdkInit.isNeedConfig = true;
var initJSSDK = function initJSSDK(config) {
  var params = getParams();
  var reConfig = _extends({}, params, config);
  if (isQw && (!reConfig.corpId || !reConfig.agentId)) {
    window.wxScrmJsdk = 'pass';
  }
  return CfxJsSdkInit.getInstance(reConfig);
};
var index = {
  initJSSDK: initJSSDK,
  jsdkAutoLoginFunc: jsdkAutoLoginFunc,
  setLoadWxSdk: setLoadWxSdk
};

export default index;
export { initJSSDK, jsdkAutoLoginFunc, setLoadWxSdk };
//# sourceMappingURL=wxjssdk.esm.js.map
